import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=82b6bc34&scoped=true&lang=pug"
import script from "./Integrations.vue?vue&type=script&lang=js"
export * from "./Integrations.vue?vue&type=script&lang=js"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=82b6bc34&prod&lang=css"
import style1 from "./Integrations.vue?vue&type=style&index=1&id=82b6bc34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b6bc34",
  null
  
)

export default component.exports